import React from 'react';

import { styleUtils } from '../../utils';
import { View, Row, Col } from '../View';
import { List } from 'semantic-ui-react'
import Text from "../Text";
import Logo from "../Logo";
import { FacebookIcon, TwitterIcon } from '../../../assets/icons';
import styles from "../Footer/styles";

const { style } = styleUtils;
const RootContainer = style('footer', styles.rootContainer);
const Nav = style('nav', styles.nav);
const ListItem = style(List.Item, styles.listItem);
const ColTitle = style(View, styles.colTitle);
const RowIcons = style(View, styles.rowIcons);
const FooterCol = style(Col, styles.col);
const FooterLink = style('a', styles.footerLink)

const Footer = () => {

  return (

      <RootContainer>
        <View className="content-wrapper">
          <Nav>
            <Row justify="space-between" type="flex">
              <FooterCol>
                <List link>
                  <ListItem as="a" href="https://www.baosystems.com/whoweare/">Who we are</ListItem>
                  <ListItem as="a" href="https://www.baosystems.com/whatwedo/">What we do</ListItem>
                  <ListItem as="a" href="https://www.baosystems.com/hosting/">Hosting</ListItem>
                  <ListItem as="a" href="https://www.baosystems.com/contact">Contact</ListItem>
                </List>
              </FooterCol>
              <FooterCol>
                <List link>
                  <ListItem as="a" href="https://baosystems.applytojob.com/">Careers at BAO Systems</ListItem>
                  <ListItem as="a" href="https://www.dhis2.org/about">What is DHIS2?</ListItem>
                  <ListItem as="a" href="https://www.baosystems.com/contact">Work with BAO Systems</ListItem>
                  <ListItem as="a"
                            href="https://www.baosystems.com/wp-content/uploads/2019/04/termsfeed-privacy-policy-2.pdf"
                  >
                    Privacy policy
                  </ListItem>
                </List>
              </FooterCol>
              <FooterCol span={6}>
                <List link>
                  <ListItem><Text>BAO SYSTEMS</Text></ListItem>
                  <ListItem as="a" href="mailto:info@baosystems.com">info@baosystems.com</ListItem>
                  <ListItem>+1 (202) 536-1543</ListItem>
                  <ListItem>2900 K Street NW, Suite 507 Washington, DC 20007, USA</ListItem>
                </List>
              </FooterCol>
              <FooterCol>
                <ColTitle><Text>STAY IN TOUCH</Text></ColTitle>
                <List link>
                  <ListItem>
                    <RowIcons>
                      <Col span={3}>
                        <FooterLink className="ui" href="http://facebook.com/baosystems"><FacebookIcon width={12} height={12} /></FooterLink>
                      </Col>
                      <Col span={3}>
                        <FooterLink className="ui" href="http://twitter.com/baosystems"><TwitterIcon width={12} height={12} /></FooterLink>
                      </Col>
                      <Col>
                        <FooterLink className="ui" href="https://www.baosystems.com/contact">CONTACT US</FooterLink>
                      </Col>
                    </RowIcons>
                  </ListItem>
                </List>
              </FooterCol>
            </Row>
          </Nav>
          <Row>
            <Col><Logo type="BAO" color="#4667ED"/></Col>
          </Row>
        </View>
      </RootContainer>

  );
};

export default Footer;
